import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default props => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode, prjId, prjTypeCode, sVer} = map.data

    if (! (
        'BM' === prjTypeCode &&
        /^(SA|_PA)_MAP$/.test(mapTypeCode)
    )) {
        return null
    }

    const onClick = async () => {
        const dpIds = []
        const names = []
        const {name, textProp} = map.BizNode.PM

        for (const n of map.selectedNodes) {
            const {bizNodeType, pkid, [textProp]: text} = n.data

            if (pkid && 'PM' === bizNodeType) {
                dpIds.push(pkid)
                names.push(text)
            }
        }

        if (0 < dpIds.length) {
            const title = `${name}: ${names.join(', ')}`

            openWindow(
                '/Ai',

                {
                    bizMap: {dpIds},
                    prjId,
                    scene: 'GENERATE_WF',
                    sVer,
                    title,
                }
            )
        }
        else {
            await openModal(
                <Alert type="error">
                    请先选择{name}
                </Alert>
            )
        }
    }

    return {
        label: '业务流程建模',
        onClick,
        ...props,
    }
}
